import { useMemo } from "react";

export function usePagination({ currentPage, totalPages, pagesToShow = 5 }) {
  // Calcul des pages à afficher basé sur la page courante
  return useMemo(() => {
    // Calculer le groupe de pages actuel
    let start = Math.max(1, currentPage - Math.floor(pagesToShow / 2));

    // Ajuster le startPage si on est proche de la fin
    if (start + pagesToShow > totalPages) {
      start = Math.max(1, totalPages - pagesToShow + 1);
    }

    const end = Math.min(totalPages, start + pagesToShow - 1);

    // Créer un tableau des pages visibles
    const pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);

    // Déterminer si on peut naviguer en avant/arrière
    const canGoBack = currentPage > 1;
    const canGoForward = currentPage < totalPages;

    return {
      startPage: start,
      endPage: end,
      visiblePages: pages,
      canGoBack,
      canGoForward,
    };
  }, [currentPage, totalPages, pagesToShow]);
}
